import LockPaywall from '@src/courseware/course/sequence/lock-paywall/LockPaywall'; // eslint-disable-line import/no-unresolved

const DefaultLockPaywall = (props) => (
  <LockPaywall {...props} />
);

export default DefaultLockPaywall;
